import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import { Center } from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/recruiting/companies/create";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import ReactSelect from "../../../../../../components/Form/ReactSelect";
import { toast, ToastContainer } from "react-toastify";
import Input from "../../../../../../components/Form/Input";
import TextArea from "../../../../../../components/Form/TextArea";
import companyActions from "../../../../../../store/actions/recruiting/company";
import { hideModal } from "../../../../../../store/actions/modal";
import { useParams } from "react-router-dom";
interface ComponentProps {
  createStates: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

const Component = ({ createStates }: ComponentProps) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();
  const params = useParams();
  const onSubmit = ({ values, actions }) => {
    dispatch(companyActions.create({ ...values, team: params.id }));
    setFormActions(actions);
  };

  useEffect(() => {
    if (createStates.success) {
      toast("👌🏼 Empresa agregada correctamente", {
        containerId: "submit",
        type: "success",
        toastId: "submitsucceful",
      });

      setTimeout(() => {
        dispatch(companyActions.resetCreate());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }

    if (createStates.error) {
      toast(`😱 ${createStates.error}`, {
        containerId: "submit",
        type: "error",
        toastId: "submiterror",
      });

      setTimeout(() => {
        dispatch(companyActions.resetCreate());
      }, 1000);
    }
  }, [createStates]);

  return (
    <Modal name="new-company-modal" title="Crear Empresa">
      <Formik
        initialValues={{ ...initialValues }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="new-company-form"
            >
              <Grid.Row>
                <Grid.Col>
                  <Input
                    name={"name"}
                    error={errors["name"]}
                    touched={touched["name"]}
                    value={values["name"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Nombre", skin: "gray" }}
                  />
                  <Input
                    name={"linkedin"}
                    error={errors["linkedin"]}
                    touched={touched["linkedin"]}
                    value={values["linkedin"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Linkedin", skin: "gray" }}
                  />
                  <Input
                    name={"email"}
                    error={errors["email"]}
                    touched={touched["email"]}
                    value={values["email"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "E-mail", skin: "gray" }}
                  />
                  <Input
                    name={"location"}
                    error={errors["location"]}
                    touched={touched["location"]}
                    value={values["location"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Ubicacion", skin: "gray" }}
                  />
                  <Input
                    name={"portfolio"}
                    error={errors["portfolio"]}
                    touched={touched["portfolio"]}
                    value={values["portfolio"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{ label: "Portfolio", skin: "gray" }}
                  />
                  <ReactSelect
                    name="area"
                    error={errors["area"]}
                    touched={touched["area"]}
                    items={
                      []
                      /*  !!abilities &&
                      abilities
                        .filter((ability) => ability.active)
                        .map((ability) => ({
                          label: ability.name,
                          value: ability._id,
                        })) */
                    }
                    placeholder="Selecciona un Rubro"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{
                      /* loading: !abilities || abilitiesStates.loading, */
                      label: "Asignar Rubro",
                      marginBottom: 24,
                      skin: "gray",
                    }}
                  />
                  <TextArea
                    name="description"
                    error={errors["description"]}
                    touched={touched["description"]}
                    value={values["description"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    options={{
                      label: "Descripcion",
                      skin: "gray",
                      marginBottom: 24,
                    }}
                  />
                </Grid.Col>
              </Grid.Row>

              <Grid.Row>
                <Grid.Col>
                  <Center gap={"70px"}>
                    <Button
                      onClick={resetForm}
                      type="button"
                      options={{
                        type: "outline",
                        skin: "gray",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      Cancelar
                    </Button>

                    <Submit
                      isSubmmiting={isSubmitting}
                      form="new-company-form"
                      color="Primary"
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};
const states = ({ recruitingStore }) => {
  const { states: createStates } = recruitingStore.company.create;
  return {
    createStates,
  };
};
export default connect(states)(Component);
